/* Generated by scripts/generate.ts from src/locales. Do not edit by hand. */
import type { NamespaceSchema } from "../catalogue";

export interface HomeCopy {
  liveDeals: {
    screenTitle: string;
    loading: string;
    emptyFiltered: string;
    emptyFilteredLong: string;
    empty: string;
    clearFilters: string;
    filterIncome: string;
    filterGrowth: string;
    dealTypeInvestment: string;
    windowOpen: string;
    windowOpenClosing: (args: { closes: string | number }) => string;
    windowComingSoon: string;
    windowOpens: (args: { opens: string | number }) => string;
    windowOpensCloses: (args: { opens: string | number; closes: string | number }) => string;
    noticeRange: (args: { min: string | number; max: string | number }) => string;
    noticeSingle: (args: { min: string | number }) => string;
    noticeChip: (args: { months: string | number }) => string;
  };
  dealCard: {
    fundraisingLimit: (args: { cap: string | number }) => string;
    remainingLeft: (args: { remaining: string | number }) => string;
    percentSubscribed: (args: { percent: string | number }) => string;
    distributionLabel: string;
    riskLabel: string;
  };
  statLabel: {
    targetRate: string;
    targetReturn: string;
    annualisedReturn: string;
    riskProfile: string;
    risk: string;
    distributionPaid: string;
    distributionsPaid: string;
    liquidity: string;
    maturity: string;
  };
  portfolio: {
    screenTitle: string;
    tabAll: (args: { count: string | number }) => string;
    tabPersonal: string;
    tabBusiness: string;
    groupOther: string;
    hideBalances: string;
    showBalances: string;
    viewDocuments: string;
    openIfIsa: string;
    seeAllUpcomingEarnings: string;
    upcomingEarningsFor: (args: { dealName: string | number }) => string;
    toggleAllocation: string;
  };
  suggested: {
    heading: string;
  };
}

export const homeSchema: NamespaceSchema = {
  namespace: "home",
  keys: {
    "liveDeals.screenTitle": [],
    "liveDeals.loading": [],
    "liveDeals.emptyFiltered": [],
    "liveDeals.emptyFilteredLong": [],
    "liveDeals.empty": [],
    "liveDeals.clearFilters": [],
    "liveDeals.filterIncome": [],
    "liveDeals.filterGrowth": [],
    "liveDeals.dealTypeInvestment": [],
    "liveDeals.windowOpen": [],
    "liveDeals.windowOpenClosing": ["closes"],
    "liveDeals.windowComingSoon": [],
    "liveDeals.windowOpens": ["opens"],
    "liveDeals.windowOpensCloses": ["opens", "closes"],
    "liveDeals.noticeRange": ["min", "max"],
    "liveDeals.noticeSingle": ["min"],
    "liveDeals.noticeChip": ["months"],
    "dealCard.fundraisingLimit": ["cap"],
    "dealCard.remainingLeft": ["remaining"],
    "dealCard.percentSubscribed": ["percent"],
    "dealCard.distributionLabel": [],
    "dealCard.riskLabel": [],
    "statLabel.targetRate": [],
    "statLabel.targetReturn": [],
    "statLabel.annualisedReturn": [],
    "statLabel.riskProfile": [],
    "statLabel.risk": [],
    "statLabel.distributionPaid": [],
    "statLabel.distributionsPaid": [],
    "statLabel.liquidity": [],
    "statLabel.maturity": [],
    "portfolio.screenTitle": [],
    "portfolio.tabAll": ["count"],
    "portfolio.tabPersonal": [],
    "portfolio.tabBusiness": [],
    "portfolio.groupOther": [],
    "portfolio.hideBalances": [],
    "portfolio.showBalances": [],
    "portfolio.viewDocuments": [],
    "portfolio.openIfIsa": [],
    "portfolio.seeAllUpcomingEarnings": [],
    "portfolio.upcomingEarningsFor": ["dealName"],
    "portfolio.toggleAllocation": [],
    "suggested.heading": [],
  },
};
